module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-xl-6",
    class: {
      'col-lg-12': _vm.canSeeExtraDetails, 'col-lg-6': _vm.cannotSeeExtraDetails
    }
  }, [_c('p', [_c('strong', [_vm._v("Additional Charge")]), _c('br'), _vm._v("\n      " + _vm._s(_vm.decorated.description) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4",
    class: {
      'col-lg-3 col-xl-1': _vm.canSeeExtraDetails, 'col-lg-2 col-xl-2': _vm.cannotSeeExtraDetails
    }
  }, [_c('p', [_c('strong', [_vm._v("Charge Type")]), _c('br'), _vm._v("\n      " + _vm._s(_vm.decorated.type) + "\n    ")])]), _vm._v(" "), (_vm.canSeeExtraDetails) ? [_c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Client Rate")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.client_rate) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-3 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("\n          Rate\n          "), _c('span', {
    class: {
      'text-success': _vm.chargeIsProfitable, 'text-danger': _vm.chargeIsNotProfitable
    },
    attrs: {
      "title": _vm.perTonneDifference
    }
  }, [_vm._v("\n            " + _vm._s(_vm.profitAsMoney) + "\n          ")])]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.carrier_rate) + "\n      ")])])] : [_c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-2 col-xl-2"
  }, [_c('p', [_c('strong', [_vm._v("Rate")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.$user.isCarrierOrDriver ? _vm.decorated.carrier_rate : _vm.decorated.client_rate) + "\n      ")])])], _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4",
    class: {
      'col-lg-3 col-xl-1': _vm.canSeeExtraDetails, 'col-lg-2 col-xl-2': _vm.cannotSeeExtraDetails
    }
  }, [_c('p', {
    staticClass: "load-cost"
  }, [_c('strong', [_vm._v("Additional Charge")]), _c('br'), _vm._v("\n\n      " + _vm._s(_vm.additionalChargesTotalAsMoney) + "\n    ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-736bb8bd"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/loads/Charge.vue
// module id = 1041
// module chunks = 0